// extracted by mini-css-extract-plugin
module.exports =  {"title":"ymoP1F","totalLine":"S5Pf9z","totalLineOld":"XKfzE9","multipleTotalsRoot":"kARi0n"};